export default {
  custom_allergen: {
    placeholder: 'Adicionar opção personalizada',
  },
  buttons: {
    add: 'Adicionar',
  },
};
